import React, { useState, useEffect, ReactNode } from 'react';
import { facultyThemes, FacultyTheme, applyTheme, ThemeContext } from '@/lib/theme';

interface ThemeProviderProps {
  children: ReactNode;
  defaultFaculty?: string;
}

export const ThemeProvider: React.FC<ThemeProviderProps> = ({
  children,
  defaultFaculty = 'default'
}) => {
  const [currentTheme, setCurrentTheme] = useState<FacultyTheme>(
    facultyThemes[defaultFaculty] || facultyThemes.default
  );

  const setTheme = (facultyKey: string) => {
    const theme = facultyThemes[facultyKey] || facultyThemes.default;
    setCurrentTheme(theme);
    applyTheme(facultyKey);
    
    // Store theme preference
    localStorage.setItem('eduvos-faculty-theme', facultyKey);
  };

  useEffect(() => {
    // Load saved theme preference
    const savedTheme = localStorage.getItem('eduvos-faculty-theme');
    if (savedTheme && facultyThemes[savedTheme]) {
      setTheme(savedTheme);
    } else {
      applyTheme(defaultFaculty);
    }
  }, [defaultFaculty]);

  return (
    <ThemeContext.Provider value={{ currentTheme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
